
async function updateSellingPlan(itemKey, sellingPlanId, itemQuantity) {
  try {

    const response = await fetch("/cart/change.js", {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({
        id: itemKey,
        selling_plan: sellingPlanId,
        quantity: itemQuantity
      })
    });

    if (!response.ok) {
      const errorText = await response.text();
      console.error("Error updating plan:", errorText);
      return;
    }

    const updatedCart = await response.json();
    console.log("Cart updated successfully", updatedCart);

    if (typeof publish === "function" && typeof PUB_SUB_EVENTS !== "undefined") {
      publish(PUB_SUB_EVENTS.cartUpdate, {
        source: "custom-subscription",
        cartData: updatedCart
      });
    }

  } catch (error) {
    console.error("Error updating selling plan:", error);
  }
}

document.addEventListener("click", async function (event) {

  if (event.target.classList.contains("st-switch-toggle")) {
    const toggle = event.target;
    const cartItem = toggle.closest(".cart-item");
    if (!cartItem) return;

    const dropdown = cartItem.querySelector(".st-subscribe-select");
    if (dropdown) {
      dropdown.classList.toggle("active");
    }

    const isActive = toggle.dataset.switch === "true";
    toggle.dataset.switch = !isActive;

    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({
      event: "side-cart-subscribe-toggle",
      subscription_status: toggle.dataset.switch === "true" ? "on" : "off"
    });

    const option = cartItem.querySelector(".st-subscribe-select-option.active") || cartItem.querySelector(".st-subscribe-select-option");
    const itemKey = dropdown.dataset.itemKey;
    const itemQuantity = dropdown.dataset.itemQuantity;
    const sellingPlanId = option.dataset.sellingPlanId;
    const planToSend = isActive ? "" : sellingPlanId;

    updateSellingPlan(itemKey, planToSend, itemQuantity);

    let hasSubscription = false;
    const toggles = document.querySelectorAll(".st-switch-toggle");
    for (const toggleBtn of toggles) {
      if (toggleBtn.dataset.switch === "true") {
        hasSubscription = true;
        break;
      }
    }

    const subscribeMessage = document.querySelector(".st-subscribe-message");
    if (subscribeMessage) {
      subscribeMessage.classList.toggle("active", hasSubscription);
    }

  }

  if (event.target.classList.contains("st-subscribe-select-dropdown")) {
    const dropdown = event.target.closest(".st-subscribe-select");
    const menu = dropdown.querySelector(".st-subscribe-select-menu");

    dropdown.classList.toggle("open");
    menu.classList.toggle("open");
    return;
  }

  if (event.target.classList.contains("st-subscribe-select-option")) {
    const option = event.target;

    const dropdown = option.closest(".st-subscribe-select");

    const toggle = dropdown.querySelector(".st-subscribe-select-dropdown");
    toggle.textContent = option.textContent.trim();

    dropdown.classList.remove("open");
    dropdown.querySelector(".st-subscribe-select-menu").classList.remove("open");

    const cartItem = option.closest(".cart-item");
    if (!cartItem) return;

    const options = cartItem.querySelectorAll(".st-subscribe-select-option");
    for (const opt of options) {
      opt.classList.remove("active");
    }
    option.classList.add("active");

    const itemKey = dropdown.dataset.itemKey;
    const itemQuantity = dropdown.dataset.itemQuantity;
    const sellingPlanId = option.dataset.sellingPlanId;

    updateSellingPlan(itemKey, sellingPlanId, itemQuantity);
  }

  document.querySelectorAll(".st-subscribe-select.open").forEach(dropdown => {
    dropdown.classList.remove("open");
    dropdown.querySelector(".st-subscribe-select-menu").classList.remove("open");
  });
});